(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('UserAdmin', UserAdmin);

    UserAdmin.$inject = ['$resource'];

    function UserAdmin ($resource) {
        var service = $resource('api/admin/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'getAllAgency':{method:'GET', isArray: true, url:'api/admin/agences'},
            'bulkUpdate': { method:'POST', url:'api/admin/users/bulk-update' },
            'exportCsv': {
                method: 'GET',
                url: 'api/admin/users/export/csv',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data, headersGetter) {
                    return {
                        response: new Blob([data], { type: headersGetter('Content-Type') || 'text/csv;charset=UTF-8' }),
                        fileName: getFileNameFromDisposition(headersGetter('Content-Disposition'))
                    };
                }
            }
        });

        return service;
    }

    function getFileNameFromDisposition(contentDisposition) {
        if (!contentDisposition) {
            return null;
        }
        var match = contentDisposition.match(/filename="(.+)"/);
        return match ? match[1] : null;
    }
})();
